module.exports = __webpack_public_path__ + "img/importstep1.d94ddec1.png";